import { styled } from '@mui/material';
import { Chip } from '../Chip';

export const Container = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  overflow: 'hidden',
  '& span:first-of-type': {
    marginLeft: 0
  }
}));
export const Wrapper = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  position: 'relative'
}));
export const SpanItem = styled('span', {
  shouldForwardProp: prop => prop !== 'isVisible' && prop !== 'hasOverflows'
})<{ isVisible: boolean; hasOverflows?: boolean }>(({ theme, isVisible, hasOverflows }) => ({
  margin: theme.spacing(0, 1),
  opacity: isVisible ? '100%' : 0,
  fontSize: theme.typography.body2.fontSize,
  display: 'flex',
  whiteSpace: 'nowrap',
  order: isVisible ? 0 : 100,
  '&:not(:first-child)': {
    maxWidth: hasOverflows ? 'calc(100% - 60px)' : 'calc(100% - 10px)'
  }
}));

export const ChipWarpper = styled('span', {
  shouldForwardProp: prop => prop !== 'isVisible' && prop !== 'hasOverflows'
})<{ isVisible: boolean; hasOverflows?: boolean }>(({ theme, isVisible, hasOverflows }) => ({
  margin: theme.spacing(0, 1),
  opacity: isVisible ? '100%' : 0,
  marginLeft: '4px',
  order: isVisible ? 0 : 100,
  flexShrink: 100,
  maxWidth: hasOverflows ? 'calc(100% - 60px)' : 'calc(100% - 10px)'
}));

export const ChipItem = styled(Chip)(() => ({
  height: '24px',
  borderRadius: '12px',
  flexShrink: 100,
  '& .MuiChip-label': {
    padding: '0 12px'
  }
}));

export const OverflowTag = styled(Chip)(({ theme }) => ({
  height: 24,
  order: 99,
  position: 'sticky',
  backgroundColor: theme.palette.grey[300],
  color: theme.palette.secondary.lighter,
  borderRadius: 12,
  textAlign: 'center',
  padding: '0 4px',
  fontSize: theme.typography.caption.fontSize,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: theme.spacing(0, 0.5),
  flexShrink: 1,
  right: 0,
  boxShadow: `-4px 0 0px ${theme.palette.grey[600]}`
}));
